export enum FrontendLocations {
  Dashboard = 'Dashboard',
  Navigation = 'Navigation',
  Watchlists = 'Watchlists',
  Exchange = 'Exchange',
  Login = 'Login',
  News = 'News',
  PassThrough = 'PassThrough',
  PromoPods = 'PromoPods',
  Tour = 'Tour',
  OmniSearch = 'OmniSearch',
  ThematicWatchlists = 'ThematicWatchlists',
  StockHeatMap = 'StockHeatMap',
  OptoWatchlists = 'OptoWatchlists'
}
